import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("pc_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

// public (no auth)
export const publicApi = axios.create({ baseURL: API });

// client (customer) self-service — separate token from staff
export const clientApi = axios.create({ baseURL: API });
clientApi.interceptors.request.use((config) => {
  const t = localStorage.getItem("pc_client_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// platform super-admin (Azordi operator) — fully separate token
export const platformApi = axios.create({ baseURL: API });
platformApi.interceptors.request.use((config) => {
  const t = localStorage.getItem("azordi_platform_token");
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});
